import { Container } from "pixi.js";

import { AbstractDisplayComponent } from "../../core/displays/AbstractDisplayComponet";
import { Character } from "./Character";

export class CharacterComponent extends AbstractDisplayComponent {
    private container: Character;

    public override init() {
        let config = {
            labelName: "characterComponent",
            anchorX: 0.5,
            anchorY: 0.5,
            landscape: {
                posX: 1750,
                posY: 1024,
                scale: 1,
            },
            portrait: {
                posX: 1310,
                posY: 410,
                scale: 1,
            }
        };

        super.init();
        this.container = new Character(config);
    }



    public getInstance(): Container {

        return this.container;

    }



    public override destroy(): void {

        this.container.destroy({ children: true });

    }



    public animateCharacter(variant?: string): void {

        this.container.animateCharacter(variant);

    }

    public resize(check: boolean){
        this.container.setCharacterPositionResize(check);
    }

    public configureForTriggeredFeatures(triggerFeatures: string[]): void {
        this.container.configureForTriggeredFeatures(triggerFeatures);
    }

}

